// Runtime AI model configuration.
// Configure this once in the host application's top-level App/Home code.
let runtimeConfig = null;

const normaliseProvider = (provider) => String(provider || '').trim().toLowerCase();

export const configureAIModel = (config) => {
  const provider = normaliseProvider(config?.provider);
  const model = String(config?.model || '').trim();
  const temperature = Number(config?.temperature);

  if (!provider || !model || !Number.isFinite(temperature)) {
    throw new Error('AI model configuration requires provider, model and a numeric temperature.');
  }

  runtimeConfig = Object.freeze({
    ...config,
    provider,
    model,
    temperature,
  });

  return runtimeConfig;
};

export const getAIModelConfig = (overrides = null) => {
  if (!runtimeConfig) {
    throw new Error('AI model has not been configured. Call configureAIModel(...) once in the host App/Home code.');
  }

  return overrides ? { ...runtimeConfig, ...overrides } : runtimeConfig;
};

export const getInvokeAIProvider = (provider) => {
  const value = normaliseProvider(provider || getAIModelConfig().provider);
  if (value === 'gemini') return 'Gemini';
  if (value === 'claude') return 'Claude';
  return 'ChatGPT';
};
